
import { computed, defineComponent, onMounted, PropType, ref } from "vue";
import { Message } from "@/types/conversation";
import { useConversation } from "@/composables/conversation";
import SpinnerAnimation from "@/components/SpinnerAnimation.vue";
import DOMPurify from "dompurify";
import { closeDialog } from "vue3-promise-dialog";
import { showTransferConversationDestinationDialog } from "@/dialogs/TransferConversationDialog";
import { TransferChannelOption } from "@/components/modals/TransferConversationModal.vue";

export default defineComponent({
  name: "MessengerMessageInlineChannelSuggestions",
  components: {},
  setup(props, { slots }) {
    const { transferChannelOptions, conversation } = useConversation();

    const requestDestination = (option: TransferChannelOption) => {
      showTransferConversationDestinationDialog(option, "none");
    };

    return {
      transferChannelOptions,
      requestDestination,
    };
  },
});
